import Vue from "vue";
import {
  message,
  Modal
} from "ant-design-vue";

const namespaced = true;

function initialState() {
  return {
    datasources: {}
  };
}

const state = {
  datasources: initialState().datasources
};

const mutations = {
  SET_DATASOURCE: (state, datasource) => {
    Vue.set(state.datasources, datasource.id, datasource);
  },
  UNSET_DATASOURCE: (state, id) => {
    Vue.delete(state.datasources, id);
  }
};

const actions = {
  create: ({
    commit
  }, datasource) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(`/admin/datasource`, {
          datasource: datasource
        })
        .then(response => {
          commit("SET_DATASOURCE", response.data.datasource);
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  saveWithPlan: ({
    commit
  }, data) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(
          `/admin/datasource/withPlan${
						data.datasource.id ? "/" + data.datasource.id : ""
					}`, {
            datasource: data.datasource,
            levels: data.levels
          }
        )
        .then(response => {
          commit("SET_DATASOURCE", response.data.datasource);
          resolve();
        })
        .catch(error => {
          // Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchSingle: ({
    commit
  }, {
    id,
    include
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/datasource/${id}${include ? "?include=" + include : ""}`)
        .then(response => {
          commit("SET_DATASOURCE", response.data.datasource);
          resolve(response.data.datasource);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  fetchAll: ({
    commit
  }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`/datasource`)
        .then(response => {
          for (const datasource of response.data.datasources) {
            commit("SET_DATASOURCE", datasource);
          }
          resolve();
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  update: ({
    commit
  }, datasource) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(`/admin/datasource/${datasource.id}`, {
          datasource: datasource
        })
        .then(response => {
          commit("SET_DATASOURCE", response.data.datasource);
          resolve(response.data.datasource);
        })
        .catch(error => {
          Vue.prototype.$log.error(error);
          reject(error);
        });
    });
  },
  delete: ({
    state,
    commit
  }, id) => {
    return new Promise((resolve, reject) => {
      const datasource = state.datasources[id];

      Modal.confirm({
        title: 'Delete booking',
        content: `Permanently delete datasource '${datasource.name}'. Continue?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk: () => {
          Vue.axios
            .delete(`/admin/datasource/${id}`)
            .then(response => {
              commit("UNSET_DATASOURCE", id);
              message.success(
                `Datasource ${
									datasource.name
								} has been deleted!`
              );
              resolve();
            })
            .catch(error => {
              message.error(
                `Error while deleting datasource ${
									datasource.name
								}!`
              );
              Vue.prototype.$log.error(error);
            });
        }
      });
    });
  }
};

const getters = {
  all: (state, getters, rootState) => {
    if (rootState.isLoading) return {};
    return state.datasources;
  },
  asArray: (state, getters, rootState) => {
    if (rootState.isLoading) return [];
    return Object.values(state.datasources);
  }
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
};